//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordStudyChip from '@/components/innovation/WordStudyChip.vue'
export default {
  components: { WordStudyChip },
  data () { return { content: '', cn: '', words: [] } },
  created () {
    this.$ajax.get(this.$api.slTeamDetail + '?id=' + this.$route.query.id).then(r => {
      this.words = r.words || []
    })
  },
  methods: {
    submit () {
      this.$ajax.post(this.$api.slStorySubmit, {
        team_id: this.$route.query.id,
        content_en: this.content,
        content_cn: this.cn
      }).then(() => {
        this.$toast && this.$toast('已提交')
        this.$router.replace({ path: '/slTeam_display', query: { id: this.$route.query.id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '提交失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/write.vue